import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter-input',
  templateUrl: './filter-input.component.html'
})
export class FilterInputComponent {
    @Output() filterChanged = new EventEmitter<string>();

     // Optional customization
  @Input() label: string = 'Filter';
  @Input() placeholder: string = 'Type to filter all columns';
  @Input() tooltip: string = 'Start typing to filter results across all columns. No need to press Enter.';

     onKeyup(event: KeyboardEvent) {
    const inputValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filterChanged.emit(inputValue);
  }

}
